'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShowPreviousConversations = undefined;

var _reselect = require('reselect');

var _getShowPreviousConversations = require('conversations-schema/operators/widget-data/getShowPreviousConversations');

var _getLatestWidgetData = require('../../widget-data/selectors/getLatestWidgetData');

var getShowPreviousConversations = exports.getShowPreviousConversations = (0, _reselect.createSelector)([_getLatestWidgetData.getLatestWidgetData], function (widgetData) {
  return (0, _getShowPreviousConversations.getShowPreviousConversations)(widgetData);
});